import React, { useState, useEffect, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import translations from '@shopify/polaris/locales/es.json';
import { AppProvider, Page, Card, DataTable, Tabs } from '@shopify/polaris';
import { render } from 'react-dom';

const propTypes = {
  title: PropTypes.string.isRequired,
  breadcrumbsURL: PropTypes.string.isRequired,

  product: PropTypes.shape({
    changelogs: PropTypes.arrayOf(PropTypes.shape({
      model_type: PropTypes.string.isRequired,
      active: PropTypes.bool.isRequired,
      created_at: PropTypes.string.isRequired,
      user_name: PropTypes.string.isRequired,
      user: PropTypes.object.isRequired,
    })).isRequired,
  }).isRequired,
}

const ProductChangelogList = (props) => {
  console.log(props);
  
  // For each Changelog, build data suited for display in the DataTable
  const buildLogsData = (modelTitle, changelogs) => {
    if(changelogs && changelogs.length > 0) {
      return changelogs.map( log => {
        let dataTableRows = []; // Rows for each attribute with their changes! Currently three value rows [ attributeName, oldValue, newValue ]
  
        Object.keys(log.data).forEach( attribute => { // For each attribute in the data of the log
          const attributeName = I18n.t(`activerecord.attributes.${log.model_type.toLowerCase()}.${attribute}`); // translate attribute name
          // If attribute is too wide to track (html) or if it is a related model, then just display that it was edited, else display detailed change for attributes
          if(attribute == 'description_html' || attribute.substr(attribute.length-3,3) == '_id') { // _id are numbers, thus no representing data of the element may be present
            dataTableRows.push([ attributeName, '', 'Editado/a' ]); // for related model or html, just display that it was edited. i.e. [Variaciones, "", Editado/a]
          }
          else {
            const changeTuple = log.data[attribute]; // [oldValue, newValue]
            // nothing is done on empty strings: '', '  ', etc.
            const oldValue = changeTuple[0] == null ? '-' : changeTuple[0];
            const newValue = changeTuple[1] == null ? '-' : changeTuple[1];
  
            if( typeof(oldValue) == 'object' || typeof(newValue) == 'object' ) {
              dataTableRows.push([ attributeName, '', 'Editado/a' ]);
            }
            else {
              dataTableRows.push([ attributeName, oldValue, newValue ]);
            }
          }
        });
        
        // console.log("Cosa", dataTableRows);
  
        return {
          ...log,
          modelTitle,
          dataTableRows: dataTableRows,
        }
      });
    }
    else{
      return [];
    }
  }

  // Combine logs for product and variants into one array of logs with extra data for display
  const renderChangelogs = () => {
    let changelogsWithData = [];
    const product = props.product;

    // Add product logs
    changelogsWithData = [
      ...buildLogsData(product.title, product.changelogs)
    ];

    // Add variant logs
    product.variants.forEach( variant => { 
      const variantLogs = buildLogsData(variant.title, variant.changelogs)
      changelogsWithData = [
        ...changelogsWithData,
        ...variantLogs,
      ]
    });

    changelogsWithData.sort((a,b) => {
      return new Date(b.created_at) - new Date(a.created_at);
    })

    return changelogsWithData;
  }

  // Build the data for the changelogs present in the product and their variants!
  const changelogsItems = useMemo( () => renderChangelogs(), []);
  console.log("Changelogs parsed", changelogsItems );

  return(
    <AppProvider i18n={translations}>
      <Page
        breadcrumbs={ [{content: I18n.t("actions.back"), url: props.breadcrumbsURL}] }
        title={ props.title }
      >
        <div className='mb10'>
          { changelogsItems.map( (log, index) => (
            <Card key={log.id} title={`${log.model_type} - ${log.modelTitle}`}>
              <Card.Section>
                <span>Cambiado por <b>{log.user_name}</b>, el {I18n.l("time.formats.long", log.created_at)}</span>
              </Card.Section>
              
              <Card.Section>
                <DataTable
                  columnContentTypes={[
                    "text",
                    "text",
                    "text",
                  ]}
                  headings={[
                    "Campo",
                    "Valor Original",
                    "Valor Nuevo",
                  ]}
                  rows={ log.dataTableRows }
                />
              </Card.Section>
            </Card>
          ))}
        </div>
      </Page>
    </AppProvider>
  )

}

export default ProductChangelogList;